import React, { FC } from 'react';
import { DynamicComponent } from '@/components';
import { TypeExplorerSliceFields } from '@/core/generated-types';

const ExplorerSlice: FC<TypeExplorerSliceFields> = ({
  anchorId,
  components,
  variant,
}) => {
  return (
    <div
      data-ga-section="explorer-section"
      data-testid="explorer-section"
      className={`mb-4 lg:container md:mb-12 lg:w-full
        ${variant === 'center' ? 'text-center' : 'text-center lg:text-left'}
      `}
    >
      <div id={anchorId} className="relative -top-[90px]" />
      <div
        className={
          variant === 'center'
            ? 'grid justify-center md:flex'
            : 'md:flex md:flex-col'
        }
      >
        {components &&
          components.map((component) => (
            <div key={component.sys.id} className="!md-h-[1000px] !leading-5">
              <DynamicComponent component={component} removeContainer />
            </div>
          ))}
      </div>
    </div>
  );
};

export default React.memo(ExplorerSlice);
